/** Monat/Tag als sortierbaren Schlüssel (lexikographisch wie (month, day)-Tupel). */
function monthDayKey(month: number, day: number): number {
  return month * 100 + day;
}

/** Liegt Monat/Tag in einem jährlich wiederkehrenden Saisonfenster? */
export function monthDayInRecurring(
  month: number,
  day: number,
  startMonth: number,
  startDay: number,
  endMonth: number,
  endDay: number,
): boolean {
  const current = monthDayKey(month, day);
  const start = monthDayKey(startMonth, startDay);
  const end = monthDayKey(endMonth, endDay);
  if (start <= end) {
    return start <= current && current <= end;
  }
  return current >= start || current <= end;
}

/**
 * Übernachtung im jährlich wiederkehrenden Fenster.
 * Der Endtag ist der letzte offene Tag: nur Abreise, keine Nacht und keine Anreise.
 */
export function monthDayIsOvernightInRecurring(
  month: number,
  day: number,
  startMonth: number,
  startDay: number,
  endMonth: number,
  endDay: number,
): boolean {
  const current = monthDayKey(month, day);
  const start = monthDayKey(startMonth, startDay);
  const end = monthDayKey(endMonth, endDay);
  if (start < end) {
    return start <= current && current < end;
  }
  if (start > end) {
    return current >= start || current < end;
  }
  return false;
}
